// externals
import { shallowEqual, useSelector } from 'react-redux';

// selectors
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// types
import type { DealHistory } from '@makemydeal/dr-dash-types';
import { TaxClasses } from '@makemydeal/dr-platform-types';

// Stable reference returned when CT property tax is disabled, so the selector never yields a new array in that case.
const NO_CT_PROPERTY_TAX_ITEMS: ReturnType<typeof offerReduxSelectors.getMonthlyPaymentTaxItems> = [];

// CT property tax (additional monthly tax) items.
// Gate the work behind the toggle and stabilize the reference with shallowEqual so this line does not
// re-render the component on every dispatch (getMonthlyPaymentTaxItems returns a new array each call).
export const useCtPropertyTaxItems = (deal?: DealHistory) => {
    const isCtPropertyTaxEnabled = useSelector(featureToggleSelectors.isCTPropertyTaxCalculationEnabled);
    return useSelector(
        (state: any) =>
            isCtPropertyTaxEnabled
                ? offerReduxSelectors
                      .getMonthlyPaymentTaxItems(offerReduxSelectors.getOffer(deal || state))
                      .filter((taxItem) => taxItem.class === TaxClasses.ADDITIONAL)
                : NO_CT_PROPERTY_TAX_ITEMS,
        shallowEqual
    );
};
